import {
  BORDER_RADIUS,
  COLORS,
  DEFAULT_TRANSITION_ALL,
  DEFAULT_BOX_SHADOW,
} from "utils/styles";
import React, { useState } from "react";

import Card from "components/Card";
import { Modal } from "react-bootstrap";
import { NARRATIVE_TYPES } from "posts/constants";
import styled from "styled-components";
import {
  getNarrativeDescription,
  getLongNarrativeDescription,
} from "posts/constants";

const Wrapper = styled(Card)`
  background: ${COLORS.WHITE};
  ${DEFAULT_BOX_SHADOW};
  padding: 1rem 0.75rem;
  margin-bottom: 0rem;
  position: relative;
`;

const Content = styled.div`
  cursor: pointer;
  line-height: 1.2;
`;
const Title = styled.span.attrs(() => ({
  className: "mabry-medium",
}))`
  display: block;
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 500;
  line-height: 1.1;
`;
const Description = styled.span`
  font-size: 0.875rem;
`;
const Icon = styled.i`
  transform: translateY(2px);
`;

const Link = styled.a.attrs({ className: "mabry-regular" })`
  color: inherit;
  ${DEFAULT_TRANSITION_ALL};
  ${BORDER_RADIUS};
  background: ${COLORS.WHITE};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  opacity: 0;

  &:hover {
    opacity: 1;
    color: inherit;
    text-decoration: none;
  }

  @media (min-width: 60em) {
    display: flex;
  }
`;
const LinkIcon = styled.i`
  color: inherit;
`;

const ModalContent = styled.div``;

function NarrativeCard({
  narrative,
  showModal,
  setShowModal,
  href,
  linkText = "Go to Profile",
}) {
  const getTitle = () => {
    return narrative;
  };

  const renderModalContent = (narrative) => {
    const descriptionArray = getLongNarrativeDescription(narrative);
    return (
      <ModalContent>
        {descriptionArray.map((d, i) => (
          <p key={`${narrative.replace(/\W/g, "-")}-modal-content-${i}`}>{d}</p>
        ))}
      </ModalContent>
    );
  };

  return (
    <Wrapper>
      <Content onClick={() => (setShowModal ? setShowModal(true) : null)}>
        <Title>
          <Icon className="material-icons-round md-dark md-18">category</Icon>{" "}
          {getTitle(narrative)}
        </Title>
        <Description>{getNarrativeDescription(narrative)}</Description>
      </Content>
      {setShowModal ? (
        <Modal
          centered
          size="lg"
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{renderModalContent(narrative)}</Modal.Body>
        </Modal>
      ) : null}
      {href ? (
        <Link href={href}>
          {linkText}
          <LinkIcon className="material-icons-round mr-2">
            chevron_right
          </LinkIcon>
        </Link>
      ) : null}
    </Wrapper>
  );
}

export default NarrativeCard;
